
import SidebarTop from "../../../assets/duotone/SidebarTop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SidebarTopIcon({ className, dataTestid = "SidebarTopIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SidebarTop data-testid={dataTestid} className={classes} {...rest} />
  );
}
